import React from 'react'
import { useSelector } from 'react-redux'

import { BarChart } from '../../../../components/Charts/BarChart'
import StatisticTabs from '../StatisticTabs'
import StatisticIntervalSelect from '../../../common/Statistic/StatisticIntervalSelect'
import GridElementContainer from '../../../../components/pages/Statistics/StatisticsContent/GridElementContainer'

import {
  selectTutorProfileStats,
  selectTutorStats,
} from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { tutorStatsDatasets } from '../../../../constants'

const StatisticCard = ({ tab, onTabChange, interval, onIntervalChange }) => {
  const tutorStats = useSelector(selectTutorStats)
  const tutorProfileStats = useSelector(selectTutorProfileStats)

  return (
    <GridElementContainer title="Statistic" className="!mt-4 mg-[50px]">
      <div className="w-full">
        <div className="w-full bg-[#FEEBDD]">
          <div className="w-full flex justify-between flex-wrap flex-col md:flex-row items-center">
            <StatisticTabs tab={tab} onTabChange={onTabChange} />

            <div className="flex items-center justify-between w-full mt-[10px] mb-[15px]">
              <div className="flex gap-[18px] items-center">
                {tutorStatsDatasets.map((tutorStatsDataset) => {
                  return (
                    <div key={`stat-${tutorStatsDataset.key}`} className="flex items-center">
                      <div
                        style={{ backgroundColor: tutorStatsDataset.color }}
                        className="w-[20px] h-[20px] rounded-[6px] border-[1px] border-[#D0D5DD]"
                      />

                      <span className="font-medium text-sm text-primary-100 ml-[8px]">
                        {tutorStatsDataset.label}
                      </span>
                    </div>
                  )
                })}
              </div>

              <StatisticIntervalSelect interval={interval} onIntervalChange={onIntervalChange} />
            </div>
          </div>
          <div className="flex">
            <div className="flex w-full">
              <div className="!mr-2">
                <div className="w-[103px] h-[62px] border-solid border-2 border-[#FFCA84] rounded-md gap-y-24 bg-[#FFF5EE]">
                  <h4 className="text-[#F79009] font-normal leading-5 text-xs ml-3">
                    Days in Apolo
                  </h4>

                  <h5 className="text-[#F67443] text-sm leading-5 font-semibold ml-3">
                    {tutorProfileStats?.days_in_apolo || 0}
                  </h5>
                </div>
                <div className="w-[103px] h-[62px] border-solid border-2 border-[#FFCA84] rounded-md gap-y-24 my-2 bg-[#FFF5EE]">
                  <h4 className="text-[#F79009] font-normal leading-5 text-xs ml-3">
                    Total Classes
                  </h4>

                  <h5 className="text-[#F67443] text-sm leading-5 font-semibold ml-3">
                    {tutorProfileStats?.total_bookings || 0}
                  </h5>
                </div>
                <div className="w-[103px] h-[62px] border-solid border-2 border-[#FFCA84] rounded-md gap-y-24 bg-[#FFF5EE]">
                  <h4 className="text-[#F79009] font-normal leading-5 text-xs ml-3">
                    Total Students
                  </h4>

                  <h5 className="text-[#F67443] text-sm leading-5 font-semibold ml-3">
                    {tutorProfileStats?.total_students || 0}
                  </h5>
                </div>
              </div>
              <div className="w-full">
                <div
                  className="w-100 px-2.5 py-3 bg-[#FFF5EE] rounded-md !border border-[#FFCA84]"
                  style={{ height: '206px' }}
                >
                  <BarChart interval={interval} stats={tutorStats} datasets={tutorStatsDatasets} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GridElementContainer>
  )
}

export default StatisticCard
